import { useState, useEffect } from "react";
import { X } from "lucide-react";

interface MobileStickyBarProps {
  onGetStarted: () => void;
}

const MobileStickyBar = ({ onGetStarted }: MobileStickyBarProps) => {
  const [dismissed, setDismissed] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 2000);
    return () => clearTimeout(timer);
  }, []);

  if (dismissed || !visible) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-50 md:hidden">
      <div className="mx-auto max-w-6xl bg-card/95 backdrop-blur-lg border-t border-border px-4 py-3 pb-[calc(0.75rem+env(safe-area-inset-bottom,0px))] flex items-center justify-between gap-3 shadow-card">
        <div className="flex-1 min-w-0">
          <p className="text-xs font-display font-bold text-foreground truncate">
            Beat the S&P or get a full refund
          </p>
          <p className="text-[10px] text-muted-foreground">Pro yearly | money-back guarantee in month 1</p>
        </div>
        <button
          onClick={onGetStarted}
          className="px-4 py-2.5 rounded-xl bg-primary text-primary-foreground text-xs font-display font-bold hover:opacity-90 transition-opacity shadow-gold shrink-0"
        >
          See Pricing
        </button>
        <button
          onClick={() => setDismissed(true)}
          className="p-1 text-muted-foreground hover:text-foreground transition-colors shrink-0"
          aria-label="Dismiss"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default MobileStickyBar;
